import sign from './sign';
import departmentSignExamine from './departmentSignExamine';
import schoolSignExamine from './schoolSignExamine';
import filings from './filings';
import declare from './declare';
import detail from './detail';
import departmentInitExamine from './departmentInitExamine';
import schoolInitExamine from './schoolInitExamine';
import alteration from './alteration';
import complete from './complete';
import departmentAlterationExamine from './departmentAlterationExamine';
import schoolAlterationExamine from './schoolAlterationExamine';
import departmentCompleteExamine from './departmentCompleteExamine';
import schoolCompleteExamine from './schoolCompleteExamine';

export default {
    sign,
    departmentSignExamine,
    schoolSignExamine,
    filings,
    declare,
    detail,
    departmentInitExamine,
    schoolInitExamine,
    alteration,
    complete,
    departmentAlterationExamine,
    schoolAlterationExamine,
    departmentCompleteExamine,
    schoolCompleteExamine
}